// Returns number to ordinal value
// ref: https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number/13627586
export default function numberOrdinal(value) {
  const valueType = typeof value;

  if (valueType === 'string') {
    value = parseInt(value);
  }

  const j = value % 10;
  const k = value % 100;

  if (j == 1 && k != 11) {
    return value + 'st';
  }
  if (j == 2 && k != 12) {
    return value + 'nd';
  }
  if (j == 3 && k != 13) {
    return value + 'rd';
  }
  return value + 'th';
}
